import BalanceIcon from "@mui/icons-material/Balance"
import GroupsIcon from "@mui/icons-material/Groups"
import AutoStoriesIcon from "@mui/icons-material/AutoStories"

export const archivosIconos = [
  {
    area: "Secretaria Administrativa",
    icon: <AutoStoriesIcon />,
  },
  {
    area: "Recursos Humanos",
    icon: <GroupsIcon />,
  },
  {
    area: "Direccion De Liquidaciones",
    icon: <BalanceIcon />,
  },
]
